import script from "./add-edit-devotion.vue?vue&type=script&setup=true&lang=js"
export * from "./add-edit-devotion.vue?vue&type=script&setup=true&lang=js"

import "./add-edit-devotion.vue?vue&type=style&index=0&id=5b41bb17&lang=css"

const __exports__ = script;

export default __exports__